"use client";

import { useEffect } from "react";
import { initPostHog } from "@/lib/posthog";

/**
 * Starts PostHog once, for every route.
 *
 * Mounted in the root layout rather than in the sign-in screen because the
 * first thing worth capturing — the invite link being opened — happens on that
 * screen's own first render, and because a candidate can land straight on the
 * runner from their student dashboard without passing through sign-in at all.
 *
 * Renders nothing; it exists to be the one "use client" leaf that keeps the
 * layout a server component.
 */
export function PostHogInit() {
  useEffect(() => initPostHog(), []);
  return null;
}
